    <template>
      <div class="gantt-demo">
        <vxe-gantt v-bind="ganttOptions" @current-row-change="currentRowChangeEvent">
          <template #action="{ row }">
            <el-link  :underline="false" style="margin-right:5px;" @click="downFile(row)"><i class="iconfont icon-bianji" style="margin-right:3px"></i>编辑</el-link>
 
          </template>
          <!-- 自定义甘特任务条 -->
          <template #task-bar="{ row }">
            <div
              class="custom-task-bar"
              :style="{
                borderColor: row.color || '#b2bcc6',
                backgroundColor: row.bgColor || 'rgba(64,158,255,0.12)',
              }"
            >
              <div
                class="task-left-dot"
                :style="{ backgroundColor: row.color || row.bgColor }"
              ></div>

              <div class="task-info">
                <span class="task-title">{{ row.title }}</span>
                <span class="task-value" v-if="row.progress">{{
                  row.progress
                }}</span>

                <!-- 负责人头像 -->
                <el-avatar
                  v-if="row.name"
                  :style="{ backgroundColor: row.color || '#999' }"
                  :size="16"
                >
                  {{ row.name }}
                </el-avatar>
              </div>
            </div>
          </template>
        </vxe-gantt>
      </div>
    </template>

    <script>
    export default {
      name: "GanttTreeDemo",
      props: {
          apiData:{
              type: Array,
          },
  
      },
      data() {
        return {
          ganttHeight: window.innerHeight - 160, // 留点 padding 或顶部空间
          ganttOptions:{
            border: true,
            height: 400,
            rowConfig: {
              isCurrent: true,
              isHover: true,
              drag: true
            },
            columnConfig: {
              resizable: true
            },
            treeConfig: {
              childrenField: "children",
              expandAll: true,
              //transform: true,
              rowField: 'id',
              parentField: 'parentId'
            },
            //启用同层级拖动
 
            rowDragConfig: {
                isPeerDrag: true
            },
            cellConfig: {
              height:40
            },
            columns: [
              { type: 'seq', width: 70 },
              { field: "title", title: "任务名称",treeNode: true,dragSort: true,minWidth:200},
              {field: "start", title: "开始时间",minWidth:80},
              {field: "end", title: "结束时间",minWidth:80},
              { field: 'action', title: '操作', fixed: 'right', width: 120, slots: { default: 'action' } }
            ],
            data: []
          },
          dialogVisible: false,
        };
      },
      mounted() {
        // 转换原始数据为甘特树状结构
        this.ganttOptions.data = this.buildGanttTree(this.apiData);
        this.ganttOptions.height = this.ganttHeight;
      },
      methods: {
        currentRowChangeEvent({ rowIndex }) {
          console.log(`行选中事件 ${rowIndex}`);
        },
        buildGanttTree(list) {
          const map = new Map();
          const roots = [];

          list.forEach(it => {
            const node = {
              id: it.PKID,
              parentId:it.PARENTNO,
              title: it.WKNM || "未命名任务",
              name: it.EMPNM2 || "",
              start: it.FRDTTM || "",
              end: it.FINDTTM || "",
              progress: it.PCT ?? 0,
              color: "#b2bcc6",
              bgColor: "rgba(64,158,255,0.12)",
              children: []
            };

            // 先放入 map
            map.set(it.CODE, node);
          });

          // 第二次遍历，直接构建父子关系
          list.forEach(it => {
            const node = map.get(it.CODE);
            if (!node) return;

            const parentNo = String(it.PARENTNO ?? "").trim();
            const parent = map.get(parentNo);

            if (!parent || parentNo === "#") {
              roots.push(node);
            } else {
              parent.children.push(node);
            }
          });

          return roots;
        }
      },
    };
    </script>

    <style lang="scss" scoped>
    .gantt-demo {
      padding: 1px;
    }

    /* 自定义甘特任务条 */
    .custom-task-bar {
      display: flex;
      align-items: center;
      width: 100%;
      height: 28px;
      padding: 0 6px;
      border: 1px solid;
      border-radius: 6px;
      box-sizing: border-box;
      font-size: 12px;
      transition: box-shadow 0.2s;
      cursor: pointer;

      &:hover {
        box-shadow: 0 0 6px rgba(199, 78, 78, 0.15);
      }
    }

    .task-left-dot {
      width: 8px;
      height: 8px;
      border-radius: 10px;
      margin-right: 6px;
    }

    .task-info {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .task-title {
      font-weight: 500;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .task-value {
      background: white;
      border-radius: 6px;
      padding: 0 4px;
      font-size: 12px;
      font-weight: bold;
      color: #333;
      border: 1px solid rgba(0, 0, 0, 0.12);
    }

    /* ⭐ 根据层级动态改字体大小（标题列） */
    ::v-deep .level-1 .vxe-cell--label {
      font-size: 16px;
      font-weight: 600;
    }

    ::v-deep .level-2 .vxe-cell--label {
      font-size: 14px;
      font-weight: 600;
    }

    ::v-deep .level-3 .vxe-cell--label {
      font-size: 14px;
      font-weight: normal;
    }
    </style>
